import React from 'react'
import { randomGnztColor, useMediaQuery } from '../helpers'
import styled from 'styled-components'
import Image from './image'
import Quote from './Quote'

const StyledImageDiv = styled.div`
  // width: ${props => (props.isMd ? 56 : 42)}px;
  // height: ${props => (props.isMd ? 56 : 42)}px;
  // align-items: center;
  background: ${props => (props.index === 0 && props.img.length > 1 ? 'transparent' : '#fff')};
  // padding: ${props => (props.index === 0 && props.img.length > 1 && !props.isMd ? 0 : 12)}px;
  border-radius: 50%;
  margin-left: ${props => (props.index === 1 && props.img.length > 1 ? -14 : 0)}px;
  z-index: ${props => (props.index === 0 && props.img.length > 1 ? 0 : 9999)};
`

const TestimonialCard = ({ clientProduct, quote, highlightedQuote, name, jobTitle, img }) => {
  const normalQuotes = quote?.split(highlightedQuote)

  // const quoteWordsCount = quote?.split(' ').length

  const isMd = useMediaQuery(992)

  const quoteElements = normalQuotes => {
    return (
      <div>
        <span>{normalQuotes[0]} </span>
        <span style={{ color: '#fff' }}>{highlightedQuote}</span>
        <span>{normalQuotes[1] ?? ''}</span>
      </div>
    )
  }

  return (
    <div
      className={`d-flex flex-column justify-content-center text-left p-4`}
      style={{ background: randomGnztColor() }}
    >
      <div className="mb-2">
        <Quote width="20" height="13" />
      </div>
      <div
        className="font-weight-bold"
        style={{
          fontSize: 18,
        }}
      >
        {quoteElements(normalQuotes)}
      </div>
      <div className="d-flex justify-content-between align-items-baseline">
        <div className="d-flex align-items-center mt-4">
          <div className="d-flex gap-0 mr-3 align-items-center">
            {img?.map((image, index) => (
              <StyledImageDiv key={index} className="align-items-center" index={index} img={img} isMd={isMd}>
                <Image
                  filename={image}
                  alt={clientProduct}
                  objectFit="cover"
                  layout="constrained"
                  style={{
                    borderRadius: index === 0 && img.length > 1 ? '50%' : 0,
                    width: 50,
                    height: 50,
                    padding: index === 0 && img.length > 1 ? 0 : 10,
                    // background: index === 0 && img.length > 1 ? 'transparent' : '#fff',
                    // marginLeft: index === 1 && img.length > 1 ? -14 : 0,
                    zIndex: index === 1 && img.length > 1 ? 9999 : 0,
                  }}
                />
              </StyledImageDiv>
            ))}
          </div>
          <div>
            <div className="font-weight-bold" style={{ fontSize: 16 }}>
              {name}
            </div>
            <div style={{ fontSize: isMd ? 16 : 13 }}>{jobTitle}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TestimonialCard
